import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaSave } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory } from 'react-router-dom';
import ReactSelect from '../../../components/ReactSelect';
import { bin2hex, dataMysql, extract, pontoVirgula } from '../../../util/util';
import { toast } from 'react-toastify';
import ItemChecklistEditavel from '../../../components/ItemChecklistEditavel';
import { FinField, FinInput } from '../../../components/FinField';
import '../../../css/financeiro-parcela-pagar.css';

const EVENTO_TIPO_OPTS = [
    { value: 'advisoryboard', label: 'Advisory Board' },
    { value: 'congresso', label: 'Congresso' },
    { value: 'convencaonacional', label: 'Convenção' },
    { value: 'estandecotapat', label: 'Estande e/ou Cota de Patrocínio' },
    { value: 'eventoexclusivo', label: 'Evento Exclusivo' },
    { value: 'eventointerno', label: 'Evento Interno' },
    { value: 'eventoterceiros', label: 'Evento de Terceiros' },
    { value: 'minimeet', label: 'Mini Meeting' },
    { value: 'orgsede', label: 'Organizado Pela Sede' },
    { value: 'simposio', label: 'Simpósio' },
];

const FORMATO_OPTS = [
    { value: 'digital', label: 'Digital' },
    { value: 'presencial', label: 'Presencial' },
    { value: 'hibrido', label: 'Híbrido' },
];

const NACIONALIDADE_OPTS = [
    { value: 'nacional', label: 'Nacional' },
    { value: 'internacional', label: 'Internacional' },
];

export default function CadastroEventoChecklistModelo({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const nomeEmpresa = localStorage.getItem("nomeEmpresa");
    const [tabState, setTabState] = useState("geral");
    const token = localStorage.getItem('token');
    const idUsuario = localStorage.getItem("idUsuario");
    const nomeUsuario = localStorage.getItem("nomeUsuario");
    const perfil = localStorage.getItem("perfil");
    const [dados, setDados] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [reload, setReload] = useState(1);
    const history = useHistory();

    const buscar = () => {
        if (id) {
            api({
                method: "get",
                action: '/eventoChecklistModelo/' + id,
                token: token,
            }).then(response => {
                var dadosRecebidos = extract({
                    jsonLaravel: response.data.data,
                    chaves: [
                        'cliente',
                    ]
                });
                setDados(dadosRecebidos);
            }).catch(err => {
                //console.log(err)
            });
        } else {
            dados.itens = [{
                atividade: { id: "", nome: "" },
                itens: []
            }];
            setDados({ ...dados });
        }
    };

    const validar = () => {
        /*
        var tipo = document.querySelector("#tipo");
        if (dados.tipo === undefined || dados.tipo === '') {
            toast.error('É necessário preencher o tipo da carta');
            setTimeout(() => {
                tipo.focus();
            }, 500);
            return false;
        }
        */
        return true;
    };

    const salvar = () => {
        if (!validar()) {
            return false;
        }
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);

        if (id) {
            api({
                method: 'put',
                action: '/eventoChecklistModelo/' + id,
                token: token,
                data: {
                    ...dados,
                }
            })
                .then(function (response) {
                    toast.success("As alterações foram salvas com sucesso!");
                    history.push("/eventoChecklistModelo");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        } else {
            api({
                method: 'post',
                action: '/eventoChecklistModelo',
                token: token,
                data: {
                    ...dados,
                }
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push("/eventoChecklistModelo");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        }
    };

    useEffect(() => {
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Modelo de Checklist</h1></div>
                </div>
                <form onSubmit={e => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                        <div className="fin-pp__filters">
                            <FinField label="Cliente">
                                <ReactSelect
                                    id="cliente"
                                    value={{ value: dados.cliente, label: dados.nomeCliente }}
                                    onChange={e => setDados({ ...dados, ...{ "cliente": e.value, "nomeCliente": e.label } })}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/participante',
                                            token: token,
                                            params: {
                                                nome: input,
                                                tipoCadastro: "cliente",
                                                situacaoRegistro: "ativo",
                                            }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map((registro) => {
                                                    var label = registro.codigo +
                                                        ' - ' + registro.nome +
                                                        (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                        (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                        (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                        (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                    return {
                                                        value: registro.id,
                                                        label: label
                                                    };
                                                });
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                            <FinField label="Tipo do Evento">
                                <ReactSelect
                                    value={{ value: dados.eventoTipo, label: dados.nomeEventoTipo }}
                                    onChange={e => setDados({ ...dados, ...{ "eventoTipo": e.value, "nomeEventoTipo": e.label } })}
                                    options={EVENTO_TIPO_OPTS}
                                />
                            </FinField>
                            <FinField label="Formato do Evento">
                                <ReactSelect
                                    value={{ value: dados.eventoTipoRealizacao, label: dados.nomeEventoTipoRealizacao }}
                                    onChange={e => setDados({ ...dados, ...{ "eventoTipoRealizacao": e.value, "nomeEventoTipoRealizacao": e.label } })}
                                    options={FORMATO_OPTS}
                                />
                            </FinField>
                            <FinField label="Nacionalidade do Evento">
                                <ReactSelect
                                    id="nacionalidade"
                                    value={{ value: dados.eventoNacionalidade, label: dados.nomeEventoNacionalidade }}
                                    onChange={e => setDados({ ...dados, ...{ "eventoNacionalidade": e.value, "nomeEventoNacionalidade": e.label } })}
                                    options={NACIONALIDADE_OPTS}
                                />
                            </FinField>
                            <FinField label="Nome do Modelo">
                                <FinInput
                                    id="nome"
                                    type="text"
                                    placeholder="Nome do Modelo"
                                    value={dados.nome || ''}
                                    onChange={e => setDados({ ...dados, ...{ "nome": e.target.value } })}
                                />
                            </FinField>
                        </div>
                    </div>
                    <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                        <div className="fin-pp__cphead" style={{ marginBottom: 12 }}>
                            <h2 className="fin-pp__cphead-title">Itens</h2>
                        </div>
                        <ItemChecklistEditavel itens={dados.itens} stateChanger={setReload} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 24 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting}>
                            {isSubmitting ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</> : <><FaSave size={16} /> Salvar</>}
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
